import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EditionComponent } from './edition/edition.component';
import { ProfileRoutingModule } from './profile.routing';
import { EmailValidator } from '@angular/forms';
import { ProfileValidator } from './profile.validators';
import { ErrorDialogComponent } from './edition/dialog/error-dialog.component';
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatDialogModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatToolbarModule,
  MatSelectModule,
  MatOptionModule,
  MatTooltipModule,
  MatTabsModule
} from '@angular/material';
import {SharedModule} from '../shared/shared.module';
import {ProfileResolver} from './profile-resolver.service';

@NgModule({
  declarations: [
    EditionComponent,
    ErrorDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatToolbarModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ProfileRoutingModule,
    SharedModule
  ],
  providers: [
    EmailValidator,
    ProfileValidator,
    ProfileResolver,
  ],
  entryComponents: [
    ErrorDialogComponent
  ]
})
export class ProfileModule {}



// WEBPACK FOOTER //
// ./src/app/profile/profile.module.ts